<template>
  <v-container class="px-0">
    <v-row justify="center" class="fill-height">
      <v-col cols="12">
        <span class="card-label page-title fw-bolder fs-3 mb-1">My Barrels</span>
      </v-col>
      <!-- Barrels -->
      <v-col cols="12" sm="10" lg="8" order="3" order-md="1">
        <div v-if="fetching" class="d-flex justify-content-center mb-3">
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <CustomerHomepageItemNotInBarrel :summary="summary"/>
        <NoBarrelExistOrderABarrel v-if="noBarrelExist"/>
        <CurrentAndOtherBarrels :customerName="summary.customerName" :customerPhoneNumber="summary.customerPhoneNumber" :barrels="summary.barrels" v-if="summary && summary.barrels && summary.barrels.length && !fetching"/>
      </v-col>
      <!-- Options -->
      <v-col cols="12" sm="8" md="6" lg="4" order="1" order-md="2">
        <CustomerSidebar
        v-if="!disableWarehouse"
          :providedNumber="summary.pybNumber"
          :customerName="summary.customerName"
          :showOrderBarrelButton="showOrderBarrelMessage"
        />
      </v-col>
      <v-col cols="12"  class="d-lg-none" order="2">
        <hr>
      </v-col>
    </v-row>
    <DisableWarehouse @showModal="disableWarehouse"/>
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </v-container>
</template>
<script>
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import SimpleBarrel from "@/components/SimpleBarrel.vue";
import CustomerSidebar from "@/components/CustomerSidebar.vue";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import CurrentAndOtherBarrels from "@/components/CurrentAndOtherBarrels.vue";
import mixins from "vue-typed-mixins";
import SupportCentre from "@/components/SupportCentre.vue";
import NoBarrelExistOrderABarrel from "@/components/NoBarrelExistOrderABarrel.vue";
import CustomerHomepageItemNotInBarrel from "@/components/CustomerHomepageItemNotInBarrel.vue";
import DisableWarehouse from "@/components/DisableWarehouse.vue";
import Appsettings from "@/config/appsettings.json";

export default mixins(SnackbarNotifierMixin).extend({
  name: "MyBarrels",
  components: {
    SimpleBarrel,
    CustomerSidebar,
    SnackbarNotifier,
    CurrentAndOtherBarrels,
    SupportCentre,
    NoBarrelExistOrderABarrel,
    CustomerHomepageItemNotInBarrel,
    DisableWarehouse
  },
  data() {
    return {
      summary: {},
      fetching: false,

    };
  },
  computed: {
    noBarrelExist(){
      return (!this.summary || !this.summary.barrels || this.summary.barrels.length == 0) && !this.fetching;
    },
    showOrderBarrelMessage() {
      return (
        (!this.summary || !this.summary.barrels || this.summary.barrels.length) && !this.fetching && this.allBarrelsClosed
      );
    },
    allBarrelsClosed(){
      const allBarrelClosed = this.summary?.barrels?.map(barrel => barrel.BarrelClosed);
      return allBarrelClosed.every(entry => entry === true);
    },
    disableWarehouse() {
      return Appsettings.DisableWarehouse ?? false;
    }
  },
  async beforeMount() {
    try {
      this.fetching = true;
      this.summary = await ApiService.Instance.customerHomepage();
      if (this.summary.pybNumber) {
        this.showNotifier({
          message: `Successfully Load Customer Info`,
          snackbarType: "success",
        });
      }
      this.fetching = false;
    } catch (e) {
      this.fetching = false;
      this.showNotifier({
        message: `Failed To Load Customer Info`,
        snackbarType: "error",
      });
      error(e);
    }
  }
});
</script>

<style></style>
